import React, { Component } from 'react'

export default class DoneIcon extends Component{
	render(){
		return(
            <i
                className="material-icons"
                style={{
                    cursor: "pointer"
                  , display: "inline-block"
				  , verticalAlign: "middle"
				  , ...this.props.style
                }}
				onClick={() => this.props.action()}
            >
                done
            </i>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/icons/DoneIcon.js